import React from "react";
import { Heading, Link, Text } from "@catchoftheday/cg-components";
import { URL_ONEPASS_LANDING } from "../../../consts";
import { BenefitIconZone, BenefitRowZone, BenefitsCopyZone } from "../../layouts/UpsellBoxLayout/UpsellBoxLayout";
import { BENEFITS } from "./benefits";
import { BenefitText } from "./BenefitText";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellBoxCopy = function UpsellBoxCopy(_ref) {
  var headingText = _ref.headingText,
      onLearnMoreClick = _ref.onLearnMoreClick;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Heading.h4, {
    fontWeight: "bold",
    fontSize: {
      md: "xl"
    },
    m: 0,
    mb: 4
  }, headingText), ___EmotionJSX(Text, {
    fontWeight: "semibold",
    m: 0,
    mb: 3
  }, "Benefits include:"), ___EmotionJSX(BenefitsCopyZone, null, BENEFITS.map(function (_ref2, idx) {
    var Icon = _ref2.Icon,
        text = _ref2.text;
    return ___EmotionJSX(BenefitRowZone, {
      key: "benefit-row-".concat(idx)
    }, ___EmotionJSX(BenefitIconZone, null, ___EmotionJSX(Icon, null)), ___EmotionJSX(BenefitText, null, text));
  })), ___EmotionJSX(Link, {
    href: URL_ONEPASS_LANDING,
    color: "inherit",
    fontWeight: "bold",
    hoverColor: "inherit",
    textDecoration: "underline",
    onClick: onLearnMoreClick
  }, "Learn more"));
};